import { FacetTypeEnum, type DateFacet } from '../../../api/model/response/facets/Facets';
import { FILTERS_ID_SEPARATOR } from '../../../constants/filterConstants';
import type { FacetChildResponse, FacetResponse } from '../../../models/cose-api/response/facet-options.model';

interface FacetResponseRich extends FacetResponse {
    fieldValue: string;
    id: string
    fieldValues: FacetChildResponseRich[]
}

interface FacetChildResponseRich extends FacetChildResponse {
    fieldName: string
    value: string
}

export function coseFacetMapper(facet: FacetResponse | FacetChildResponse, isChild = false): FacetResponseRich | FacetChildResponseRich {
    let fieldValue: string;
    const key = isChild ? 'value' : 'displayName';

    if(facet[key] && isChild) {
      fieldValue = facet[key];
      return {...{ fieldValue }, ...facet} as FacetResponseRich;
    }

    const fieldName = facet[key] || 'default';
    return {...{ fieldName }, ...facet} as FacetChildResponseRich;
}

export function mapCharacteristics(facetsToMap: Array<Object>) {
    const CHARACTERISTICS = 'characteristics';
    let facetsWithI3Characteristics = [];
    (facetsToMap as Array<Object>).forEach((el) => {
        if (el['id'] === CHARACTERISTICS) {
          facetsWithI3Characteristics = [
            ...facetsToMap,
            ...el['children'],
          ];
        }
    });

    if(facetsWithI3Characteristics.length === 0) facetsWithI3Characteristics = facetsToMap;

    facetsWithI3Characteristics = facetsWithI3Characteristics
      .map((el) => {
          if (!el['id']) {
            el['id'] = CHARACTERISTICS + FILTERS_ID_SEPARATOR + el['value'];
          }
          return el;
      })
      .filter((el) => el['displayName'] !== CHARACTERISTICS);
    return facetsWithI3Characteristics;
}

export function coseFacetsMapper(facets: Array<FacetResponse|FacetChildResponse>, isChild = false) {
    return [...facets].map(facet => {
        if(facet.children && facet.children.length) {
          const facetValues = {
            children: coseFacetsMapper(facet.children as FacetChildResponse[], true),
            fieldValues: coseFacetsMapper(facet.children as FacetChildResponse[], true)
          };
          return {...coseFacetMapper(facet, isChild), ...facetValues};
        }
        const {children, ...rest} = facet;//eslint-disable-line @typescript-eslint/no-unused-vars
        return coseFacetMapper({...rest, ...{children:[]}} , isChild);
    });
}

export function mapCoseDateFacets(facet: FacetResponse) {
    if(facet.type === FacetTypeEnum.Date){
      const childrens = mapDateFacetChildren(facet.children);
      return <DateFacet> {
        type: facet.type,
        id: facet.id,
        children: childrens
      };
    }
}


function mapDateFacetChildren(children: FacetChildResponse[]) {
    const childrens = [];
    children.filter(child => {
        childrens.push({
          type: child.type,
          value: child.value
        });
    });

    return childrens;
}
